export const SECONDS_IN_MIN = 60;
export const SECONDS_IN_HR: number = SECONDS_IN_MIN * 60;
export const LS_PROVIDER_KEY = 'aiMateSmartLinkProviders';
export const LS_CHAT_LOAD_PREFERENCE_KEY = 'aiMateChatLoadPreference';
export const CSM_AI_EXPERIENCE_ID = 'csm-ai';
/**
 * If you are updating this, please also update the pollinator repo so it will not fail during transition period
 * https://bitbucket.org/atlassian/pm2-ai-mate
 */
export const POLLINATOR_TEST_IDS = {
	NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
	THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button',
};

/**
 * The maximum number of characters that can be entered in the chat input.
 */
export const MAX_CHARACTERS_INPUT = 16000;

// ldiniz3.jira-dev.com
export const SAC_STAGING_SITE_ID = 'a31a2fe0-e186-4d91-ab3d-22eeaeac5306';
// leadership circle support site
export const LEADERSHIP_CIRCLE_PROD_SUPPORT_SITE_HOSTNAME = 'support.center.leadershipcircle.com';

/** Rovo Service Agent experience id */
export const ROVO_SERVICE_AGENT_EXPERIENCE_ID = 'rovo-for-service';
export const AI_MATE_EXPERIENCE_ID = 'ai-mate';

// Widget IDs

// https://support.center.leadershipcircle.com/helpcenter/customer/
export const LEADERSHIP_CIRCLE_PROD_CUSTOMER_WIDGET_ID = 'f6150521-3b8a-4691-b05e-4bb48d1449f8';
// https://support.center.leadershipcircle.com/helpcenter/partner/
export const LEADERSHIP_CIRCLE_PROD_PARTNER_WIDGET_ID = '54ef6923-585d-4ea9-a10c-b0682063c123';
